import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {

  [types.SET_LEARNING_RESULT](state, learningResult) {
    Vue.set(state.learningResults, learningResult.assignment_id, learningResult);
  },

  [types.SET_CLASS_RANKS](state, { rankRatio, assignmentId }) {
    if (!state.learningResults[assignmentId]) {
      Vue.set(state.learningResults, assignmentId, {});
    }
    Vue.set(state.learningResults[assignmentId], 'class_ranks', rankRatio);
  },

  [types.SET_ALL_RANKS](state, { rankRatio, assignmentId }) {
    if (!state.learningResults[assignmentId]) {
      Vue.set(state.learningResults, assignmentId, {});
    }
    Vue.set(state.learningResults[assignmentId], 'all_ranks', rankRatio);
  },

  [types.SHOW_FORCE_RESULT](state) {
    Vue.set(state, 'isForceResult', true);
  },

  [types.SET_LEARNING_RESULT_STATS](state, assignmentStats) {
    Vue.set(state, 'assignmentStats', assignmentStats);
  },

};

export default mutations;
